import Textarea from 'components/formComponents/Base/Textarea';
import FormBlock from 'components/formComponents/Layout/FormBlock';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../pages/FormPage.module.scss';
import { useAppSelector } from '../../../../../hooks';

const infoText =
  'T.ex. ange ifall medarbetaren jobbar kvar på arbetsplatsen, har möjlighet att ta ett samtal med TSL under arbetstid, har behov av tolk eller annat som kan vara relevant i detta projekt. Ange även ifall du vill att vi ska kontakta dig för ytterligare information.';

const OtherInfo = () => {
  const { pageTexts } = useAppSelector((state) => state.partyApplication);
  const texts = useMemo(() => {
    return pageTexts?.otherInfoSection;
  }, [pageTexts]);

  const { watch } = useFormContext();
  const otherInfo = watch('otherInfo');
  useEffect(() => {}, [otherInfo]);
  return (
    <FormBlock
      title={texts?.otherInfoHeadline ?? 'Övriga kommentarer till TSL'}
    >
      <div
        className={styles.preamble}
        dangerouslySetInnerHTML={{
          __html: texts?.otherInfoPreamble ?? infoText,
        }}
      />
      <Textarea
        name="otherInfo"
        label={texts?.otherInfoComment?.label ?? 'Kommentar'}
        placeholder={texts?.otherInfoComment?.placeholder ?? 'Skriv...'}
        max={200}
      />
    </FormBlock>
  );
};

export default OtherInfo;
